// Extend the Navigator interface globally to include connection
interface NetworkInformation extends EventTarget {
  saveData?: boolean
  downlink?: number
  effectiveType?: string
  rtt?: number
}

interface Navigator {
  connection?: NetworkInformation
}

import { useEffect, useState } from 'react'

const useLowPower = () => {
  const [isLowPowerDevice, setIsLowPowerDevice] = useState(false)

  useEffect(() => {
    const checkLowPowerMode = () => {
      let lowPowerDetected = false

      // Check if Data Saver mode is enabled (using Network Information API)
      if ((navigator as Navigator) && 'connection' in navigator) {
        const connection = navigator.connection as NetworkInformation
        if (connection.saveData) {
          lowPowerDetected = true
        }
      }

      // Create a video element dynamically
      const video = document.createElement('video')
      video.src =
        'https://github.com/mediaelement/mediaelement-files/raw/master/big_buck_bunny.mp4'
      video.muted = true
      video.playsInline = true
      video.width = 1
      video.height = 1
      video.style.display = 'none' // Hide the video element

      // Append the video to the body to test playback
      document.body.appendChild(video)

      video
        .play()
        .then(() => {
          // Video played successfully inline
          setIsLowPowerDevice(lowPowerDetected)
        })
        .catch(() => {
          // Video did not play inline, possibly energy-saving mode or other restrictions
          setIsLowPowerDevice(true)
        })
        .finally(() => {
          // Clean up the video element after the test
          document.body.removeChild(video)
        })
    }

    checkLowPowerMode()
  }, [])

  return isLowPowerDevice
}

export default useLowPower
